import { DEFAULT_FILTER_VALUES, OVERVIEW_DASHBOARD_FILTER_DEMO_DATA } from 'src/utils/const';
import { PriceTiers } from 'src/interfaces/idashboard';
import { FilterVal } from 'src/interfaces/iproptypes';
import {
  GET_SEARCH_LOAD_END,
  GET_SEARCH_LOAD_START,
  GET_TAILORED_REGION_MARKERS_SUCCESS,
  GET_REVIEW_STREAM_LOAD_START,
  GET_REVIEW_STREAM_LOAD_END,
  SEARCH_CHANGE,
  SET_USER_INFO,
  GET_COMPSETS_LOAD_START,
  GET_COMPSETS_LOAD_END,
  GET_COMPSET_LOAD_START,
  GET_COMPSET_LOAD_END,
  GET_COMPSET_LISTING_IDS_LOAD_START,
  GET_COMPSET_LISTING_IDS_LOAD_END,
  SET_IS_USER_ALLOWED,
  GET_USER_AIRBNB_LISTINGS_LOAD_START,
  GET_USER_AIRBNB_LISTINGS_LOAD_END,
  SET_CURRENCY,
  SET_SEARCH_LIMIT_BOX_ALERT,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  SET_REV_POTENTIAL_RANGE_INVESTMENT,
  SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_BOUNDS_MAP_INSIGHTS,
  SET_FILTERS_INSIGHTS,
  SET_FILTER_INSIGHTS_ACTIVE,
  SET_USER_COUNTRY_CODE,
  SET_USER_PREF_COUNTRY_CODE,
  SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  SET_HISTORICAL_DATA,
  SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  GET_CACHED_SEARCH_MARKETS,
  SET_TOP_BANNER_OPEN,
  SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  SET_SEARCHED_MARKET_ESTIMATOR,
  GET_MARKET_CACHED_DATA,
  SET_MARKET_CACHED_DATA,
  SET_MARKET_DASHBOARD_FILTER_DATA,
  SET_PRICE_TIERS,
  UPDATE_PRICE_TIERS,
  GET_EXPLORER_MARKETS,
  SET_EXPLORER_MARKETS,
  SET_LOCKED_MARKET_DUMMY_DATA,
  SET_IS_CACHED_MARKET_DATA_SAMPLE,
  SET_LEAD_FORM_SOURCE,
  DEDUCT_ESTIMATOR_CREDIT,
  SET_USED_VERIFIED,
  SET_VISIBLE_LISTING_IDS,
  GET_VISIBLE_MAP_SUPPLY_LOAD_START,
  SET_VISIBLE_MAP_SUPPLY,
  SET_TOP_10_MARKETS_COUNTRY_WISE,
  SET_TOP_HOSTS,
  SET_HIDDEN_SUBMARKETS,
  GET_HIDDEN_SUBMARKETS_LOAD_START,
  GET_CLUSTERS_LOAD_START,
  GET_CLUSTERS_LOAD_END,
  SET_MARKET_CACHED_DATA_WITH_FILTERS,
  GET_MARKET_CACHED_DATA_WITH_FILTERS,
  SET_NO_DATA_WITH_CURRENT_FILTER,
  GET_MAP_OVERVIEW_KPI_LOAD_START,
  SET_MAP_OVERVIEW_KPI,
  SET_SELECTED_LIST,
  SET_LAST_SAVED_MARKET_NAMES,
  SET_OPEN_SAVED_MARKETS_CTA_MODAL,
  SELECTED_LIST_LOADING,
  SET_SELECTED_LIST_ERROR,
  SET_ALL_SAVED_MARKET_LISTS,
  SET_ALL_SAVED_MARKET_LISTS_LOADING,
  UPDATE_LIST_MARKETS_COUNT_IN_ALL_SAVED_MARKET_LISTS,
  UPDATE_USER_MARKET_EXPLORER_ROW_DATA_EXPORT_USAGE,
  GET_MARKET_GRADE_LOAD_START,
  SET_MARKET_GRADE,
  SET_MARKET_GRADE_ERROR,
  SET_MARKET_GRADE_404_ERROR,
  UPDATE_USER_MARKET_SUMMARY_PDF_EXPORT_USAGE,
  GET_MARKETS_IN_MAP_VIEWPORT_LOAD_START,
  SET_MARKETS_IN_MAP_VIEWPORT,
  SET_CACHED_MARKET_DATA_RATE_LIMITED,
  SET_MAP_LISTINGS_RATE_LIMITED,
  SET_TOP_HOSTS_RATE_LIMITED,
  SET_TAILORED_REGION_CREATION_RATE_LIMITED,
  SET_LAST_PERFORMANCE_PROCESSED_MONTH,
} from 'src/store/Dashboard/types';

const initialState = {
  visibleMapSupply: {
    data: null,
    loading: true,
  },
  visibleListingIDs: [] as string[],
  filteredListingsDashboard: {
    loading: true,
    data: {
      propertyType: null,
      propertySize: null,
      bathroomNumber: null,
      adrRange: null,
      ratingRange: null,
      minNightRange: null,
      listingsPerHost: null,
      propertyTypeMetricsDistribution: {},
    },
    sample_data: {
      propertyType: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.propertyType,
      propertySize: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.propertySize,
      bathroomNumber: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.bathroomNumber,
      adrRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.adrRange,
      ratingRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.ratingRange,
      minNightRange: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.minNightRange,
      listingsPerHost: OVERVIEW_DASHBOARD_FILTER_DEMO_DATA.listingsPerHost,
      // TODO: add demo data for distribution
      propertyTypeMetricsDistribution: {},
    },
  },
  tailoredRegionMarkers: [],
  reviewStream: {
    data: null,
    loading: true,
  },
  search: {
    data: {
      name: '',
      city: '',
      country: '',
      lat: null,
      lng: null,
      polygon: '',
      countryCode: '',
      bounds: null,
      isVerified: false,
      marketID: null,
      cachedFilesCount: null,
      annualAppreciation: '',
      property_price: '',
      created_by: '',
      visibility: '',
      id: null,
      marketBlogLink: null,
      parentMarketID: null,
    },
    loading: true,
  },
  user: {
    userName: 'Trial',
    email: 'Trial',
    regions: [],
    role: 'non-admin',
    userDescription: 'Trial',
    credits: 0,
    estimatorCredits: 0,
    userSignUpDay: '',
    isAirbnbLoggedIn: false,
    betaUser: true,
    isSubscribed: false,
    isVerified: false,
    hasAdditionalFreeMonthTrial: false,
    ab_test_pricing_group: '',
    estimatorRegions: [],
    nationwideAccess: [],
    blockListingExport: false,
    active_regions_metadata: [],
    workbooks: [],
    customerID: '',
    signupCountryCode: '',
    country_wide_access_list: [],
    isGlobalPlanUser: false,
    showDiscoveryAI: true,
    isAdvancePlanUser: false,
    subscriptionPlan: 'starter',
    loading: true,
    savedMarketComparisons: [],
    bestMarketFinderUsage: {},
    userStrategy: '',
    marketExplorerSearchHistory: [],
    marketExplorerRowDataExportUsage: {},
    stripeAccount: null,
    marketDashboardExportUsage: {},
  },
  bookingChanges: {
    data: null,
    loading: true,
  },
  compsets: {
    data: null,
    loading: true,
  },
  compset: {
    data: null,
    loading: true,
  },
  compsetListingIDs: {
    data: null,
    loading: true,
  },
  isUserAllowed: false,
  userAirbnbListings: {
    data: null,
    loading: true,
  },
  currency: 'USD',
  searchLimitAlertBox: false,
  nearbyRecommendedMarkets: {
    data: null,
    loading: true,
    notSupportedSearches: [],
  },
  revPotentialRangeInvestment: [],
  priceTiers: {
    Budget: {
      range: [],
      toggled: false,
    },
    Economy: {
      range: [],
      toggled: false,
    },
    Midscale: {
      range: [],
      toggled: false,
    },
    Upscale: {
      range: [],
      toggled: false,
    },
    Luxury: {
      range: [],
      toggled: false,
    },
  } as PriceTiers,
  googleAutocompleteSessionToken: null,
  googleAutocompleteSessionTokenTimeStamp: null,
  boundsMapInsights: null,
  filtersInsights: {
    roomType: [...DEFAULT_FILTER_VALUES.roomType],
    bedrooms: [...DEFAULT_FILTER_VALUES.bedrooms],
    bathrooms: [...DEFAULT_FILTER_VALUES.bathrooms],
    revenueFilter: [...DEFAULT_FILTER_VALUES.revenueFilter],
    priceTierFilter: [...DEFAULT_FILTER_VALUES.priceTierFilter],
    accommodates: [...DEFAULT_FILTER_VALUES.accommodates],
    minimum_nights: [...DEFAULT_FILTER_VALUES.minimum_nights],
    number_of_reviews: DEFAULT_FILTER_VALUES.number_of_reviews,
    rating: [...DEFAULT_FILTER_VALUES.rating],
    hostType: DEFAULT_FILTER_VALUES.hostType,
    amenities: { ...DEFAULT_FILTER_VALUES.amenities },
    showAllBookingComListings: false,
  } as FilterVal,
  userCountryCode: undefined,
  userPrefCountryCode: undefined,
  filterInsightsActive: false,
  historicalData: null,
  annualRevenueForCalculator: 0,
  cachedSearchMarkets: null,
  isTopBannerOpen: false,
  maxSampleRevPotentialPropertySize: 0,
  estimatorSearchMarket: '',
  cachedMarketData: {
    loading: true,
    data: null,
    isRateLimited: false,
  },
  cachedMarketDataWithoutFilters: null,
  noDataWithCurrentFilter: false,
  cachedIndividualOverviewComponentLoading: {},
  isCachedMarketDataSample: false,
  explorerMarkets: {
    loading: true,
    data: [],
  },
  lockedMarketData: {
    data: null,
  },
  leadFormSource: '',
  cachedTop10MarketCountryWise: null,
  topHosts: {
    data: null,
    loading: true,
    isUserAllowedToHostData: false,
    isRateLimited: false,
  },
  hiddenSubmarkets: {
    data: [],
    loading: true,
  },
  clusters: {
    data: [],
    loading: true,
  },
  mapOverviewKpi: {
    data: {
      supply: null,
      adr: null,
      occupancy_rate: null,
      revenue: null,
    },
    loading: true,
  },
  savedMarkets: {
    data: {
      id: null,
      name: '',
      marketIDs: {},
      marketDetails: {},
      isDefault: true,
    },
    loading: true,
    lastSavedMarketNames: [],
    openSavedMarketsCTAModal: false,
    isError: false,
  },
  allSavedMarketLists: {
    data: [],
    loading: true,
  },
  marketGrade: {
    data: null,
    loading: true,
    isError: false,
    is404Error: false,
  },
  marketsInMapViewport: {
    data: [],
    loading: false,
  },
  mapListings: {
    isRateLimited: false,
  },
  tailoredRegionCreationRateLimited: false,
  lastPerformanceProcessedMonth: null,
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
    case GET_TAILORED_REGION_MARKERS_SUCCESS:
      return { ...state, tailoredRegionMarkers: action.payload };
    case GET_REVIEW_STREAM_LOAD_START:
      return { ...state, reviewStream: { ...state.reviewStream, loading: true } };
    case GET_REVIEW_STREAM_LOAD_END:
      return { ...state, reviewStream: { data: action.payload, loading: false } };
    case GET_SEARCH_LOAD_START:
      return { ...state, search: { ...state.search, loading: true } };
    case GET_SEARCH_LOAD_END:
      return { ...state, search: { ...state.search, loading: false } };
    case SEARCH_CHANGE:
      return { ...state, search: { ...state.search, ...action.payload } };
    case SET_USER_INFO:
      return { ...state, user: { ...action.payload } };
    case GET_COMPSETS_LOAD_START:
      return { ...state, compsets: { ...state.compsets, loading: true } };
    case GET_COMPSETS_LOAD_END:
      return { ...state, compsets: { data: action.payload, loading: false } };
    case GET_COMPSET_LOAD_START:
      return { ...state, compset: { ...state.compset, loading: true } };
    case GET_COMPSET_LOAD_END:
      return { ...state, compset: { data: action.payload, loading: false } };
    case GET_COMPSET_LISTING_IDS_LOAD_START:
      return { ...state, compsetListingIDs: { ...state.compsetListingIDs, loading: true } };
    case GET_COMPSET_LISTING_IDS_LOAD_END:
      return { ...state, compsetListingIDs: { data: action.payload, loading: false } };
    case SET_IS_USER_ALLOWED:
      return { ...state, isUserAllowed: action.payload };
    case GET_USER_AIRBNB_LISTINGS_LOAD_START:
      return { ...state, userAirbnbListings: { ...state.userAirbnbListings, loading: true } };
    case GET_USER_AIRBNB_LISTINGS_LOAD_END:
      return { ...state, userAirbnbListings: { data: action.payload, loading: false } };
    case SET_CURRENCY:
      return { ...state, currency: action.payload };
    case SET_SEARCH_LIMIT_BOX_ALERT:
      return { ...state, searchLimitAlertBox: action.payload };
    case GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START:
      return {
        ...state,
        nearbyRecommendedMarkets: { ...state.nearbyRecommendedMarkets, loading: true },
      };
    case GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END:
      return {
        ...state,
        nearbyRecommendedMarkets: {
          data: action.payload.message,
          loading: false,
          notSupportedSearches: action.payload.notSupportedInputs,
        },
      };
    case SET_REV_POTENTIAL_RANGE_INVESTMENT:
      const revenueRangeObj = {};
      for (let revenue of action.payload) {
        revenueRangeObj[revenue] = 'visible';
      }
      return { ...state, revPotentialRangeInvestment: revenueRangeObj };
    case SET_INDIVIDUAL_REV_POTENTIAL_RANGE:
      return { ...state, revPotentialRangeInvestment: action.payload };
    case SET_PRICE_TIERS:
      const adrLTMRange = action.payload;
      const priceTiers = {
        Budget: {
          range: [0, adrLTMRange[0]],
          toggled: false,
        },
        Economy: {
          range: [adrLTMRange[0], adrLTMRange[1]],
          toggled: false,
        },
        Midscale: {
          range: [adrLTMRange[1], adrLTMRange[2]],
          toggled: false,
        },
        Upscale: {
          range: [adrLTMRange[2], adrLTMRange[3]],
          toggled: false,
        },
        Luxury: {
          range: [adrLTMRange[3], 999999],
          toggled: false,
        },
      };
      return { ...state, priceTiers: priceTiers };
    case UPDATE_PRICE_TIERS:
      return { ...state, priceTiers: action.payload };
    case SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN:
      return {
        ...state,
        googleAutocompleteSessionToken: action.payload,
        googleAutocompleteSessionTokenTimeStamp: Date.now(),
      };
    case EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN:
      return {
        ...state,
        googleAutocompleteSessionToken: null,
        googleAutocompleteSessionTokenTimeStamp: null,
      };
    case SET_BOUNDS_MAP_INSIGHTS:
      return { ...state, boundsMapInsights: action.payload };
    case SET_FILTERS_INSIGHTS:
      return { ...state, filtersInsights: action.payload };
    case SET_FILTER_INSIGHTS_ACTIVE:
      return { ...state, filterInsightsActive: action.payload };
    case SET_USER_COUNTRY_CODE:
      return { ...state, userCountryCode: action.payload };
    case SET_USER_PREF_COUNTRY_CODE:
      return { ...state, userPrefCountryCode: action.payload };
    case SET_HISTORICAL_DATA:
      return { ...state, historicalData: action.payload };
    case SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR:
      return { ...state, annualRevenueForCalculator: action.payload };
    case GET_CACHED_SEARCH_MARKETS:
      return { ...state, cachedSearchMarkets: action.payload };
    case SET_TOP_BANNER_OPEN:
      return { ...state, isTopBannerOpen: action.payload };
    case SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE:
      return { ...state, maxSampleRevPotentialPropertySize: action.payload };
    case SET_SEARCHED_MARKET_ESTIMATOR:
      return { ...state, estimatorSearchMarket: action.payload };
    case GET_MARKET_CACHED_DATA:
      return {
        ...state,
        cachedMarketData: { loading: true, data: null },
        cachedMarketDataWithoutFilters: null,
        noDataWithCurrentFilter: false,
      };
    case SET_MARKET_CACHED_DATA:
      return {
        ...state,
        cachedMarketData: { loading: false, data: action.payload },
        cachedMarketDataWithoutFilters: action.payload,
        noDataWithCurrentFilter: false,
      };
    case GET_MARKET_CACHED_DATA_WITH_FILTERS:
      return {
        ...state,
        cachedMarketData: { loading: true, data: state.cachedMarketData.data },
        noDataWithCurrentFilter: false,
      };
    case SET_MARKET_CACHED_DATA_WITH_FILTERS:
      return {
        ...state,
        cachedMarketData: { loading: false, data: action.payload },
        noDataWithCurrentFilter: false,
      };
    case SET_NO_DATA_WITH_CURRENT_FILTER:
      return { ...state, noDataWithCurrentFilter: true };
    case SET_IS_CACHED_MARKET_DATA_SAMPLE:
      return { ...state, isCachedMarketDataSample: action.payload };
    case SET_MARKET_DASHBOARD_FILTER_DATA:
      return { ...state, filteredListingsDashboard: { loading: false, data: action.payload } };
    case GET_EXPLORER_MARKETS:
      return { ...state, explorerMarkets: { ...state.explorerMarkets, loading: true } };
    case SET_EXPLORER_MARKETS:
      return { ...state, explorerMarkets: { data: action.payload, loading: false } };

    case SET_LOCKED_MARKET_DUMMY_DATA:
      return { ...state, lockedMarketData: { data: action.payload } };
    case SET_LEAD_FORM_SOURCE:
      return { ...state, leadFormSource: action.payload };
    case DEDUCT_ESTIMATOR_CREDIT:
      return {
        ...state,
        user: { ...state.user, estimatorCredits: state.user.estimatorCredits - 1 },
      };
    case SET_USED_VERIFIED:
      return { ...state, user: { ...state.user, isVerified: true } };
    case SET_VISIBLE_LISTING_IDS:
      return { ...state, visibleListingIDs: action.payload };
    case GET_VISIBLE_MAP_SUPPLY_LOAD_START:
      return { ...state, visibleMapSupply: { ...state.visibleMapSupply, loading: true } };
    case SET_VISIBLE_MAP_SUPPLY:
      return { ...state, visibleMapSupply: { data: action.payload, loading: false } };
    case SET_TOP_10_MARKETS_COUNTRY_WISE:
      return { ...state, cachedTop10MarketCountryWise: { ...action.payload } };
    case SET_TOP_HOSTS:
      return { ...state, topHosts: action.payload };
    case GET_HIDDEN_SUBMARKETS_LOAD_START:
      return { ...state, hiddenSubmarkets: { ...state.hiddenSubmarkets, loading: true } };
    case SET_HIDDEN_SUBMARKETS:
      return { ...state, hiddenSubmarkets: { data: action.payload, loading: false } };
    case GET_CLUSTERS_LOAD_START:
      return {
        ...state,
        clusters: {
          ...state.clusters,
          loading: true,
        },
      };
    case GET_CLUSTERS_LOAD_END:
      return {
        ...state,
        clusters: {
          data: action.payload,
          loading: false,
        },
      };
    case GET_MAP_OVERVIEW_KPI_LOAD_START:
      return { ...state, mapOverviewKpi: { ...state.mapOverviewKpi, loading: true } };
    case SET_MAP_OVERVIEW_KPI:
      return { ...state, mapOverviewKpi: { data: action.payload, loading: false } };
    case SET_SELECTED_LIST:
      return {
        ...state,
        savedMarkets: {
          ...state.savedMarkets,
          data: action.payload,
          loading: false,
        },
      };
    case SET_LAST_SAVED_MARKET_NAMES:
      return {
        ...state,
        savedMarkets: {
          ...state.savedMarkets,
          lastSavedMarketNames: action.payload,
          isError: false,
        },
      };
    case SET_OPEN_SAVED_MARKETS_CTA_MODAL:
      return {
        ...state,
        savedMarkets: {
          ...state.savedMarkets,
          openSavedMarketsCTAModal: action.payload,
        },
      };
    case SELECTED_LIST_LOADING:
      return {
        ...state,
        savedMarkets: {
          ...state.savedMarkets,
          loading: action.payload,
        },
      };
    case SET_SELECTED_LIST_ERROR:
      return {
        ...state,
        savedMarkets: {
          ...state.savedMarkets,
          isError: action.payload,
          loading: false,
        },
      };
    case SET_ALL_SAVED_MARKET_LISTS:
      return {
        ...state,
        allSavedMarketLists: {
          data: action.payload,
          loading: false,
        },
      };
    case SET_ALL_SAVED_MARKET_LISTS_LOADING:
      return {
        ...state,
        allSavedMarketLists: {
          ...state.allSavedMarketLists,
          loading: action.payload,
        },
      };
    case UPDATE_LIST_MARKETS_COUNT_IN_ALL_SAVED_MARKET_LISTS:
      return {
        ...state,
        allSavedMarketLists: {
          ...state.allSavedMarketLists,
          data: state.allSavedMarketLists.data.map((list: any) =>
            list.list_id === action.payload.listId
              ? { ...list, count: (list.count || 0) + action.payload.count }
              : list
          ),
        },
      };
    case UPDATE_USER_MARKET_EXPLORER_ROW_DATA_EXPORT_USAGE:
      const currentYearMonthString = new Date().toISOString().slice(0, 7);
      return {
        ...state,
        user: {
          ...state.user,
          marketExplorerRowDataExportUsage: {
            ...state.user.marketExplorerRowDataExportUsage,
            [currentYearMonthString]:
              (state.user.marketExplorerRowDataExportUsage[currentYearMonthString] || 0) +
              action.payload,
          },
        },
      };
    case GET_MARKET_GRADE_LOAD_START:
      return { ...state, marketGrade: { data: null, loading: true } };
    case SET_MARKET_GRADE:
      return { ...state, marketGrade: { data: action.payload, loading: false } };
    case SET_MARKET_GRADE_ERROR:
      return { ...state, marketGrade: { ...state.marketGrade, isError: true } };
    case SET_MARKET_GRADE_404_ERROR:
      return { ...state, marketGrade: { ...state.marketGrade, is404Error: true } };
    case UPDATE_USER_MARKET_SUMMARY_PDF_EXPORT_USAGE:
      const yearMonthString = new Date().toISOString().slice(0, 7);
      return {
        ...state,
        user: {
          ...state.user,
          marketDashboardExportUsage: {
            ...state.user.marketDashboardExportUsage,
            [yearMonthString]:
              (state.user.marketDashboardExportUsage[yearMonthString] || 0) + action.payload,
          },
        },
      };
    case GET_MARKETS_IN_MAP_VIEWPORT_LOAD_START:
      return { ...state, marketsInMapViewport: { ...state.marketsInMapViewport, loading: true } };
    case SET_MARKETS_IN_MAP_VIEWPORT:
      return { ...state, marketsInMapViewport: { data: action.payload, loading: false } };
    case SET_CACHED_MARKET_DATA_RATE_LIMITED:
      return { ...state, cachedMarketData: { ...state.cachedMarketData, isRateLimited: action.payload } };
    case SET_MAP_LISTINGS_RATE_LIMITED:
      return { ...state, mapListings: { isRateLimited: action.payload } };
    case SET_TOP_HOSTS_RATE_LIMITED:
      return { ...state, topHosts: { ...state.topHosts, isRateLimited: action.payload } };
    case SET_TAILORED_REGION_CREATION_RATE_LIMITED:
      return { ...state, tailoredRegionCreationRateLimited: action.payload };
    case SET_LAST_PERFORMANCE_PROCESSED_MONTH:
      return { ...state, lastPerformanceProcessedMonth: action.payload };
  }
};
